<template>

<div class="cookie" v-show="showCookie">
    <div class="wrapper">
        <div class="cookie__wrapper">
            <div class="cookie__content">
                <slot></slot>
            </div>
            <div class="cookie__aside">
                <div @click="hideBanner">
                    <slot name="button"></slot>
                </div>
            </div>
        </div>
    </div>
</div>
    
</template>

<script>


    export default {

        data() {
            return {
                showCookie: false,
                expiryDate: 1000*60*60*24*30, 
                timestamp: localStorage.getItem('cookie')
            }
        },

        mounted() {
            this.shouldShow()
        },

        methods: {

            shouldShow() {

                if(this.timestamp === null || parseInt(this.timestamp)+this.expiryDate < Date.now()){
                    this.showCookie = true;
                }

            },

            hideBanner() {
                this.showCookie = false;
                localStorage.setItem('cookie',Date.now());
            }
        }
        
    }

</script>